/* eslint-disable */
import React, { useState, useEffect } from "react";


import { countries } from '../../assets/nationalities';

import { useTranslation } from "react-i18next";
const AddressRegistration = ({ register, errors, setValue, values = null }) => {

  const { t } = useTranslation();
  return (
    <>

      <div className="row">



        <div className="input-block mb-3">
          <label className="form-control-label">{t("Street / Building / House No.")}</label>
          <input
            className="form-control"
            type="text"

            {...register("street")}
          />
          <p className="text-danger">{errors.street?.message}</p>
        </div>

      </div>

      <div className="row">



        <div className="col-md-6">
          <div className="input-block mb-3">
            <label className="form-control-label">{t("Postal Code")}</label>
            <input
              className="form-control"
              type="text"

              {...register("postal_code")}
            />
            <p className="text-danger" >{errors.postal_code?.message}</p>
          </div>
        </div>
     
      <div className="col-md-6">
        <div className="input-block mb-3">
          <label htmlFor="region" className="form-label">{t("Country")}</label>
          <select
            className="form-select py-2"
            style={{ fontSize: "14px" }}
            id="region"
            {...register("region")}
            onChange={(e) => setValue("region", e.target.value || "")}

          >
            <option value="">{t("Select your Country")}</option>
            {countries.map((nation) => (
              <option key={nation} value={nation}>
                {nation}
              </option>
            ))}
          </select>
          <p className="text-danger">{errors.region?.message}</p>
        </div>
        </div>
      </div>


    </>
  );
};
export default AddressRegistration;
